// Importación de imágenes para mejor optimización
import heroBg from './img/hero-bg.jpg';
import about from './img/about.jpg';
import logo from './img/logo.png';

export const images = {
  heroBg,
  about,
  logo,
};

export default images;